<div class="container">
  <article>
    <header (click)="handleToggleAccordion()">
      <strong>Filtro</strong>
      <img
        class="accordion-img"
        [ngClass]="{ 'rotate-animation': !isOpen }"
        src="assets/icons/arrow.svg"
      />
    </header>

    <main [ngClass]="{ 'is-collapsed': !isOpen }">
      <div main class="main">
        <div class="grid-content">
          <div class="period">
            <app-input
              label="Data de Atendimento"
              placeholder="De"
              [control]="form.controls.startDate"
              [disabled]="false"
              [type]="InputTypeEnum.date"
              [errorMessage]="'campo obrigatório'"
              [error]="!form.controls.startDate.valid"
            ></app-input>
            <app-input
              label=""
              placeholder="Até"
              [control]="form.controls.endDate"
              [disabled]="false"
              [type]="InputTypeEnum.date"
              [errorMessage]="'campo obrigatório'"
              [error]="!form.controls.endDate.valid"
            ></app-input>
          </div>

          <app-select-multi
            label="Clientes"
            placeholder="Selecione múltiplos clientes"
            [multiControl]="form.controls.clients"
            [selected]="selectedClients"
            [options]="clients"
            [multi]="true"
            [disabled]="loadingClients"
            [loading]="loadingClients"
            (searchValueEmmiter)="getClients($event)"
            [isPaged]="true"
            [isSearch]="true"
            [isDinamicSearch]="true"
            [loadingSearch]="loadingSearchClients"
            [loadingPage]="loadingMoreClients"
            (scrollEndedEmmiter)="getMoreClients()"
            errorMessage="campo obrigatório"
          >
          </app-select-multi>

          <app-select-multi
            label="Skills"
            placeholder="Selecione múltiplas skills"
            [multiControl]="form.controls.skills"
            [selected]="selectedSkills"
            [options]="skills"
            [multi]="true"
            [disabled]="loadingSkills"
            [loading]="loadingSkills"
            (searchValueEmmiter)="getSkills()"
            [isPaged]="true"
            [loadingPage]="loadingMoreSkills"
            (scrollEndedEmmiter)="getMoreSkills()"
            errorMessage="campo obrigatório"
          >
          </app-select-multi>

          <app-select-multi
            label="Células"
            placeholder="Selecione múltiplas células"
            [multiControl]="form.controls.cells"
            [selected]="selectedCells"
            [options]="cells"
            [multi]="true"
            [disabled]="loadingCells"
            [loading]="loadingCells"
            (searchValueEmmiter)="getCells()"
            [isPaged]="true"
            [loadingPage]="loadingMoreCells"
            (scrollEndedEmmiter)="getMoreCells()"
            errorMessage="campo obrigatório"
          >
          </app-select-multi>

          <app-select-multi
            label="Sub-células"
            placeholder="Selecione múltiplas sub-células"
            [multiControl]="form.controls.subCells"
            [selected]="selectedSubCells"
            [options]="subCells"
            [multi]="true"
            [disabled]="loadingSubcells"
            [loading]="loadingSubcells"
            (searchValueEmmiter)="getSubCells()"
            [isPaged]="true"
            [loadingPage]="loadingMoreSubCells"
            (scrollEndedEmmiter)="getMoreSubCells()"
            errorMessage="campo obrigatório"
          >
          </app-select-multi>

          <app-select-multi
            label="Categorias"
            placeholder="Selecione múltiplas categorias"
            [multiControl]="form.controls.categories"
            [selected]="selectedCategories"
            [options]="categories"
            [multi]="true"
            [disabled]="loadingCategories"
            [loading]="loadingCategories"
            (searchValueEmmiter)="getCategories($event)"
            [isPaged]="true"
            [isSearch]="true"
            [isDinamicSearch]="true"
            [loadingSearch]="loadingSearchCategories"
            [loadingPage]="loadingMoreCategories"
            (scrollEndedEmmiter)="getMoreCategories()"
            errorMessage="campo obrigatório"
          >
          </app-select-multi>

          <app-select-multi
            label="Atendentes"
            placeholder="Selecione múltiplos atendentes"
            [multiControl]="form.controls.attendants"
            [selected]="selectedAttendants"
            [options]="attendants"
            [multi]="true"
            [disabled]="loadingAttendants"
            [loading]="loadingAttendants"
            (searchValueEmmiter)="getAttendants($event)"
            [isPaged]="true"
            [isSearch]="true"
            [isDinamicSearch]="true"
            [loadingSearch]="loadingSearchAttendants"
            [loadingPage]="loadingMoreAttendants"
            (scrollEndedEmmiter)="getMoreAttendants()"
            errorMessage="campo obrigatório"
          >
          </app-select-multi>

          <app-select-multi
            label="Turnos"
            placeholder="Selecione múltiplos turnos"
            [multiControl]="form.controls.shifts"
            [options]="shifts"
            [selected]="selectedShifts"
            property="Type"
            [multi]="true"
            [disabled]="loadingShifts"
            [loading]="loadingShifts"
          ></app-select-multi>

          <app-select-multi
            label="Tipos"
            placeholder="Selecione múltiplos tipos"
            [multiControl]="form.controls.types"
            [options]="types"
            [selected]="selectedTypes"
            property="Type"
            [disabled]="false"
            [multi]="true"
          ></app-select-multi>

          <app-select
            label="Tema da Nuvem"
            placeholder="Selecione um tema para a nuvem"
            errorMessage="campo obrigatório"
            [options]="cloudThemes"
            [control]="form.controls.cloudTheme"
            [error]="
              !form.controls.cloudTheme.valid &&
              !form.controls.cloudTheme.pristine
            "
            [disabled]="loadingCloudThemes"
            [loading]="loadingCloudThemes"
          ></app-select>

          <app-select
            *ngIf="showOffender"
            label="Ofensor por:"
            placeholder="Selecione um item"
            errorMessage="campo obrigatório"
            [options]="offenderOptions"
            [control]="form.controls.offender"
            [error]="!form.controls.offender.valid"
          ></app-select>

          <app-select
            *ngIf="showContactReasonType"
            label="Motivo"
            placeholder="Selecione o tipo do Motivo de Contato"
            errorMessage="campo obrigatório"
            [options]="contactReasonTypeOptions"
            [control]="form.controls.contactReasonType"
            [error]="!form.controls.contactReasonType.valid"
          ></app-select>
        </div>
      </div>

      <hr />

      <div footer class="footer">
        <app-secondary-button
          (click)="clear()"
          label="Limpar"
          [color]="ButtonColorEnum.warning"
          [icon]="'assets/icons/trash.svg'"
          [enabled]="true"
          [widthFull]="true"
        >
        </app-secondary-button>
        <app-primary-button
          [label]="'Filtrar'"
          [color]="ButtonColorEnum.common"
          [loading]="isLoading"
          (clickFunc)="search()"
          [enabled]="form.valid"
        ></app-primary-button>
      </div>
    </main>
  </article>
</div>
